import { render, staticRenderFns } from "./InterazioneFarmaciView.vue?vue&type=template&id=7dba5d9d&scoped=true"
import script from "./InterazioneFarmaciView.vue?vue&type=script&lang=js"
export * from "./InterazioneFarmaciView.vue?vue&type=script&lang=js"
import style0 from "./InterazioneFarmaciView.vue?vue&type=style&index=0&id=7dba5d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dba5d9d",
  null
  
)

export default component.exports